import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { FormsModule } from '@angular/forms';

import { Auth, CommonService, SnackbarService } from '../../services';
import { Constants } from '../../common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule,
    MatButtonModule
],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login.component.scss',
})
export class LoginComponent {

  email = '';
  password = '';

  constructor(public commonService: CommonService, private auth: Auth, private router: Router, private snackbarService: SnackbarService) { }

  login() {
    this.commonService.showSpinner = true;
    this.auth.login(this.email, this.password).subscribe({
      next: (result) => {
        // Assume result indicates success, e.g., a token or success flag
        if (result) {
          this.router.navigate([Constants.APP_ROUTES.home]);
          this.snackbarService.open(result);
        } else {
          this.snackbarService.open(result);
        }
        this.commonService.showSpinner = false;
      },
      error: (err: string) => {
        // Handle request error
        this.snackbarService.open(err);
        this.commonService.showSpinner = false;
      }
    });
  }

}
